import * as tslib_1 from "tslib";
import { AuthorizeBaseDirective } from './authorize-base.directive';
var AuthorizeDirective = /** @class */ (function (_super) {
    tslib_1.__extends(AuthorizeDirective, _super);
    function AuthorizeDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthorizeDirective.prototype._isGranted = function (permission) {
        return this._appState.user.permissions.isGranted(permission);
    };
    Object.defineProperty(AuthorizeDirective.prototype, "permission", {
        set: function (permission) {
            this._permission = permission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeDirective.prototype, "permissionDisable", {
        set: function (permission) {
            this._permissionDisable = permission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeDirective.prototype, "permissionAny", {
        set: function (permissions) {
            this._permissionAny = permissions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeDirective.prototype, "permissionAnyDisable", {
        set: function (permissions) {
            this._permissionAnyDisable = permissions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeDirective.prototype, "permissionAll", {
        set: function (permissions) {
            this._permissionAll = permissions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthorizeDirective.prototype, "permissionAllDisable", {
        set: function (permissions) {
            this._permissionAllDisable = permissions;
        },
        enumerable: true,
        configurable: true
    });
    return AuthorizeDirective;
}(AuthorizeBaseDirective));
export { AuthorizeDirective };
